import model from 'modules/company/companyModel';

const { fields } = model;

export default [
  fields.name,
  fields.logo,
  fields.type,
  fields.externalId,
  fields.allowCollectExpiredOrder,
  fields.attachments,
  fields.parent,
  fields.building,
];
